

































































































































import GoToReferenceButton from "@/components/partner/GoToReferenceButton.vue";
import SideCard from "@/components/utility/SideCard.vue";
import { simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { ISignDocument } from "@/models/sign-document.entity";
import { mixins } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";
import DocumentDetailMixin from "./DocumentDetailMixin.vue";
import { requiredRule } from "@/lib/rules/requiredRule";
import SelectTags from "@/components/tag/v2/SelectTags.vue";
import TagChip from "@/components/tag/TagChip.vue";
import Tooltip from "@/components/utility/tooltip.vue";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { PartnerModule } from "@/store/modules/partner";
import { PartnerTypeEnum } from "@/store/enum/partner/partner.type.enum";

@Component({
  components: {
    SideCard,
    GoToReferenceButton,
    SelectTags,
    TagChip,
    Tooltip
  }
})
export default class DocumentTemplateDetailInformation extends mixins(DocumentDetailMixin, PermissionMixin) {
  @Prop()
  document!: ISignDocument;

  PartnerTypeEnum = PartnerTypeEnum;

  edit = false;
  isValid = false;

  get partner() {
    return PartnerModule.partner;
  }

  get partnerId() {
    return this.document.partnerId;
  }

  get subtitle() {
    return `
      ${this.$t("sign.DocumentTemplateDetailInformation.created")}:
      ${simpleDoubleDigitDate(this.document.timestamp?.created)}
    `;
  }

  get requiredRule() {
    return [requiredRule()];
  }

  save() {
    this.edit = false;
    this.$emit("save");
  }

  removeWhiteSpace() {
    if (this.document.folder) {
      this.document.folder = this.document.folder.replace(/\s/g, "");
    }
  }
}
